import { Box, Grid, Theme, useMediaQuery } from '@mui/material';
import { CkeditorContentSkeleton } from '../../../../../components/ckeditor-content/CkeditorContentSkeleton';
import { programDetailStyles } from '../styles';
import { ProgramDetailHeaderSkeleton } from './ProgramDetailHeaderSkeleton';
import { ProgramStickyCardSkeleton } from './ProgramStickyCardSkeleton';

export const ProgramDetailPageSkeleton: React.FC = () => {
  const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up('lg'));
  return (
    <Box className="container-fluid">
      <Grid container spacing={0}>
        <Grid item xs={12} lg={8} xl={9}>
          <ProgramDetailHeaderSkeleton />
          <Box sx={{ mr: { lg: 2.5 }, my: 7.5 }} id="about-program">
            <CkeditorContentSkeleton />
          </Box>
        </Grid>
        {isDesktop && (
          <Grid item xs={12} lg={4} xl={3}>
            <Box sx={programDetailStyles.programStickyCardWrapper}>
              <ProgramStickyCardSkeleton />
            </Box>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};
